module.exports = __webpack_public_path__ + "static/email-template-account-activation-esai-ac50bbd1ce8beef406208dd9df375b12.jpg";